var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('Slider',{attrs:{"data":_vm.popularMovieList}})],1),_c('div',{staticClass:"ml-5 mt-5"},[_c('CategoryMovies')],1),(!_vm.$route.meta.hideNavbar)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }